import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Timer } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { Button } from '@/shared/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { cn } from '@/core/lib/utils';
import { TimerDisplay } from './TimerDisplay';
import { GlobalTimerPopover } from './GlobalTimerPopover';
import { useActiveTimer } from '../hooks/useActiveTimer';

export function GlobalTimerWidget() {
  const { t } = useTranslation('timeTracking');
  const { data: activeTimer } = useActiveTimer();
  const [open, setOpen] = useState(false);

  const hasActiveTimer = !!activeTimer?.id;
  const tooltipLabel = hasActiveTimer ? t('timer.running') : t('timer.idle');

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-8 gap-1.5 px-2"
              aria-label={tooltipLabel}
              data-testid="time-tracking-global-widget"
            >
              <Timer
                className={cn(
                  'h-4 w-4 shrink-0',
                  hasActiveTimer ? 'text-green-600' : 'text-muted-foreground',
                )}
                aria-hidden="true"
              />
              {hasActiveTimer && (
                <>
                  <TimerDisplay
                    startTime={activeTimer.startTime}
                    className="hidden text-sm font-medium tabular-nums md:inline"
                  />
                  <span className="hidden max-w-30 truncate text-xs text-muted-foreground lg:inline">
                    {activeTimer.task.title}
                  </span>
                </>
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{tooltipLabel}</TooltipContent>
      </Tooltip>

      <PopoverContent
        align="end"
        className="p-0"
        data-testid="time-tracking-global-popover-wrapper"
      >
        <GlobalTimerPopover />
      </PopoverContent>
    </Popover>
  );
}
